import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Dropdown, Option } from "./Dropdown";
import { Form, Button, Modal } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import Toggle from "react-toggle";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  TextareaAutosize,
  TextField,
} from "@mui/material";

import { format } from "date-fns";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

let tempArr = [];

const ViewTicket = ({ history, match }) => {
  const [dap_users, setUsers] = useState([]);
  // const [users, setUsers] = useState({});
  const [dap_name, setName] = useState("");
  const [dap_date, setDate] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_dob, setDOB] = useState("");
  const [dap_billable, setBillable] = useState(false);
  const [dap_billable1, setBillable1] = useState(false);
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [leadExecutiveName, setLeadExecutiveName] = useState("");

  const [ticketId, setTicketId] = useState("");
  const [executive, setExecutive] = useState({});
  const [executiveName, setExecutiveName] = useState("");
  const [customer, setCustomer] = useState({});
  const [description, setDescription] = useState("");
  const [ticket_oid, setTicket_oid] = useState("");
  const [ticketStatus, setTicketStatus] = useState({});
  const [updatedAt, setUpdatedAt] = useState("");
  const [images, setImages] = useState([]);
  const [showImage, setShowImage] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showFollowUp, setShowFollowUp] = useState(false);
  const [imgUrl, setImageUrl] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [goBackLink, setGoBackLink] = useState("/support-tickets");
  const [response, setResponse] = useState({
    label: "Not Responded",
    value: false,
  });
  const [mode, setMode] = useState("");
  const [note, setNote] = useState("");
  const [followup, setFollowup] = useState([]);
  const [contactedBy, setContactedBy] = useState("");

  const [modeErrors, setModeErrors] = useState({});
  const [noteErrors, setNoteErrors] = useState({});
  const [userType, setUserType] = useState("");

  const [uploadFiles, setUploadFiles] = useState([]);
  const [fileArr, setFileArr] = useState([]);

  const { SearchBar } = Search;
  // const ws = new WebSocket('ws://localhost:3002');
  const ws = new WebSocket("ws://localhost:3002");

  useEffect(() => {
    let id = match.params.id;
    ws.onopen = () => {
      // Send a message to the server to specify the group and content
      console.log("Websocket Connected");
    };
    //  console.log(id);getLead(id);
    getTicket(id);
    let user = JSON.parse(localStorage.getItem("user"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));

    let isPartner = localStorage.getItem("isPartnerLogin");
    if (isPartner) {
      setGoBackLink("/supports");
    }
    console.log("authority", userDetails.data.authority == "SYS_ADMIN");
    if (userDetails.data.authority == "SYS_ADMIN") {
      setGoBackLink("/supports");
    } else if (userDetails.data.authority == "itexecutive") {
      setGoBackLink("/supports");
    } else if (userDetails.data.authority == "CUSTOMER_USER") {
      setGoBackLink("/my-supports");
    }
    setContactedBy(user._id);
    setUserType(userDetails.data.authority);
    setLoading(true);

    ws.onmessage = (event) => {
      console.log("Received message from server:", event.data);
      if (event.data != "online") {
        console.log("Received message ", id);
        getFollowUp(
          environment.dap_url + "support/getFollowUpByTicketId?id=" + id
        );
      }
    };

    return () => {
      // Close the WebSocket connection when the component unmounts
      ws.close();
    };
  }, []);

  const getRecentChats = (id) => {
    axios
      .get(environment.dap_url + "support/recentChats?id=" + id)
      .then((chat) => {
        console.log("Received Message", tempArr);
        tempArr.push(chat.data[0]);
        setFollowup(tempArr);
        let supportChat = document.getElementById("support-Mpanel");
        let supportChatInner = document.getElementById("support-MInnerPanel");
        console.log("mPanel", supportChat.scrollHeight);
        console.log("mPanel Inner", supportChatInner.scrollHeight);
        supportChat.scrollTo({ top: supportChatInner.scrollHeight });
      });
  };

  const getFollowUp = (url) => {
    console.log("Received Message", followup);
    axios
      .get(url)
      .then((res) => {
        console.log("followup", res.data[0]);
        setFollowup(res.data.reverse());
        let supportChat = document.getElementById("support-Mpanel");
        let supportChatInner = document.getElementById("support-MInnerPanel");
        console.log("mPanel", supportChat.scrollHeight);
        console.log("mPanel Inner", supportChatInner.scrollHeight);
        supportChat.scrollTo({ top: supportChatInner.scrollHeight });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTicket = (id) => {
    axios
      .get(environment.dap_url + "support/getSupportById?id=" + id)
      .then((res) => {
        console.log("res", res.data);
        let ticket = res.data[0];
        setTicketId(ticket.ticketId);
        setDescription(ticket.description);
        setTicket_oid(ticket._id);
        setImages(ticket.file);
        let updatedDateTimeArr = ticket.updatedAt.split("T");
        let updatedDateArr = updatedDateTimeArr[0].split("-");
        let updatedTimeArr = updatedDateTimeArr[1].split(":");
        setUpdatedAt(
          updatedDateArr[2] +
            "-" +
            updatedDateArr[1] +
            "-" +
            updatedDateArr[0] +
            " " +
            updatedTimeArr[0] +
            ":" +
            updatedTimeArr[1]
        );
        console.log(ticket.executive_details);
        if (ticket.executive_details.length > 0) {
          setExecutive(ticket.executive_details[0]);
          setExecutiveName(
            ticket.executive_details[0].userFirstName +
              " " +
              ticket.executive_details[0].userLastName
          );
        }
        let customer = ticket.customer_details[0];
        setCustomer(customer);
        setName(customer.userFirstName + " " + customer.userLastName);
        setEmail(customer.email);
        setPhone(customer.phone);
        setPostCountry(customer.country);
        setPostState(customer.state);
        setPostCity(customer.city);
        setAddress(customer.address);
        setZip(customer.zip);
        switch (ticket.status) {
          case "created":
            setTicketStatus({ label: "Created", value: ticket.status });
            break;
          case "assigned":
            setTicketStatus({ label: "Assigned", value: ticket.status });
            break;
          case "in-progress":
            setTicketStatus({ label: "In Progress", value: ticket.status });
            break;
          case "hold":
            setTicketStatus({ label: "Hold", value: ticket.status });
            break;
          case "closed":
            setTicketStatus({ label: "Closed", value: ticket.status });
            break;
          default:
            break;
        }
        let isItExecutive = localStorage.getItem("isItExecutive");
        if (isItExecutive) {
          // let followupUrl = environment.dap_url+"support/getFollowUpByCustomerAndExecutive?customerId="+customer._id+"&executiveId="+ticket.executive_details[0]._id
          let followupUrl =
            environment.dap_url + "support/getFollowUpByTicketId?id=" + id;
          getFollowUp(followupUrl);
        } else {
          let followupUrl =
            environment.dap_url + "support/getFollowUpByTicketId?id=" + id;
          getFollowUp(followupUrl);
        }

        ws.send(JSON.stringify({ group: ticket.ticketId, content: "online" }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submitHandler = (e) => {};

  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        let dateTimeArr = dataField.split("T");
        let dateArr = dateTimeArr[0].split("-");
        let dateFinal = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        return dateFinal;
      },
    },
    {
      dataField: "note",
      text: "Note",
      sort: true,
    },
    {
      dataField: "mode",
      text: "Mode",
      sort: true,
    },
    {
      dataField: "dataField",
      text: "ContactedBy",
      sort: true,
      formatter: (row, col, rowIndex, formatExtraData) => {
        console.log("col", col);
        if (col.executive_details.length > 0) {
          return (
            col.executive_details[0].userFirstName +
            " " +
            col.executive_details[0].userLastName
          );
        } else {
          return "";
        }
      },
    },
  ];

  const changeStatus = (e) => {
    console.log(e.value);
    setTicketStatus({ label: e.label, value: e.value });

    if (e.value == "close") {
      MySwal.fire({
        title: "Are you sure to close this ticket?",
        icon: "warning",
        text: "Once you close the ticket, you will not able to reopen it.",
        showCancelButton: true,
        confirmButtonText: "Yes",
        //cancelButtonColor: "btn-light",
        //className: "Custom_Cancel",
      }).then(function (result) {
        if (result.isConfirmed) {
          updateStatus("closed");
        } else {
          getTicket(ticket_oid);
        }
      });
    } else {
      updateStatus(e.value);
    }
  };

  const updateStatus = (s) => {
    axios
      .put(environment.dap_url + "support/updateStatus?id=" + ticket_oid, {
        status: s,
      })
      .then((res) => {
        if (res.data.status == true) {
          MySwal.fire({
            title: "Ticket Updated",
            icon: "success",
          });
          getTicket(ticket_oid);
        } else {
          MySwal.fire({
            title: "Error Occured",
            icon: "error",
            text: "An error occured while updating the status",
          });
        }
      })
      .catch((err) => {
        MySwal.fire({
          title: "Error Occured",
          icon: "error",
          text: err,
        });
      });
  };

  const openImage = (src) => {
    setImageUrl(src);
    setShowImage(true);
  };
  const openPdf = (url) => {
    setPdfUrl(environment.dap_url + "" + url);
    setShowPdf(true);
  };

  const openVideo = (url) => {
    setVideoUrl(environment.dap_url + "" + url);
    setShowVideo(true);
  };

  const handleChangeSelect = (e) => {
    console.log(e.value);
    setResponse({ label: e.label, value: e.value });
  };

  const formValidation = () => {
    const modeError = {};
    const noteError = {};

    let isValid = true;
    // if (!mode) {
    //   modeError.error = "Mode is required";
    //   isValid = false;
    // }
    if (!note) {
      noteError.error = "Note is required";
      isValid = false;
    }

    setModeErrors(modeError);
    setNoteErrors(noteError);

    return isValid;
  };

  const submitResponse = (e) => {
    e.preventDefault();
    console.log("clicked");
    let isValid = formValidation();
    if (isValid) {
      // let reqBody = {
      //   ticketId: ticketId,
      //   ticket_oid: ticket_oid,
      //   customerId: customer._id,
      //   executiveId: contactedBy,
      //   mode: "chat",
      //   note: note,
      //   response: "true",
      //   files:uploadFiles
      // };

      const formData = new FormData();
      formData.append("ticketId", ticketId);
      formData.append("ticket_oid", ticket_oid);
      formData.append("customerId", customer._id);
      formData.append("executiveId", contactedBy);
      formData.append("mode", "chat");
      formData.append("note", note);
      formData.append("response", true);
      let farr = [];
      console.log("onsubmit", uploadFiles);
      uploadFiles.forEach((f) => {
        formData.append("files", f);
      });
      // console.log(reqBody);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post(environment.dap_url + "support/addFollowUp", formData, config)
        .then((res) => {
          console.log(res);
          setNote("");
          setFileArr([]);
          setUploadFiles([]);
          getTicket(ticket_oid);
          ws.send(JSON.stringify({ group: ticketId, content: note }));
        });
    }
  };

  const renderFileContent = (fileObject) => {
    const fileExtension = fileObject.type.split("/")[1];
    console.log(fileExtension);
    if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
      return <img src={fileObject.file} style={{ width: "100px" }} />;
    } else if (fileExtension === "pdf") {
      return (
        <embed
          src={fileObject.file}
          width="100px"
          height="100px"
          type="application/pdf"
        />
      );
    } else if (["mp4", "avi", "mov"].includes(fileExtension)) {
      return (
        <video width="100px" height="100px" controls>
          <source src={fileObject.file} type={`video/${fileExtension}`} />
          Your browser does not support the video tag.
        </video>
      );
    } else {
      return <p>Unsupported file type</p>;
    }
  };

  const handleChangeForFile = (e) => {
    console.log("handle change");
    const file = e.target.files[0];
    const uploadFile = [...uploadFiles];
    const f = [...fileArr];
    console.log(file);
    f.push({ file: URL.createObjectURL(e.target.files[0]), type: file.type });
    setFileArr(f);
    uploadFile.push(file);
    setUploadFiles(uploadFile, file);
  };
  const remove = (e, i) => {
    console.log(i);
    let f = [...fileArr];
    let uploadFile = [...uploadFiles];
    uploadFile.splice(i, 1);
    setUploadFiles(uploadFile);
    f.splice(i, 1);
    console.log(uploadFile);
    setFileArr(f);
  };

  return (
    <div className="container-fluid">
      {/* <div className="row" style={{ color: "black" }}></div> */}

      <div className="container-fluid mt-5 mx-3">
        <Link to={goBackLink} className="btn btn-light my-3">
          Go Back
        </Link>
      </div>
      <div className="container-fluid m-3">
        <div className="row justify-content-center m-2" id="support-container">
          <div className="col-4 border" id="support-details">
            <div className="support-card border-bottom py-3">
              <h5>
                <b>Ticket Details</b>
              </h5>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th scope="row">Ticket Id</th>
                    <td>{ticketId}</td>
                  </tr>
                  <tr>
                    <th scope="row">Assigned to</th>
                    <td>{executiveName}</td>
                  </tr>
                  <tr>
                    <th scope="row">Description</th>
                    <td>{description}</td>
                  </tr>
                  <tr>
                    <th scope="row">Images</th>
                    <td style={{ display: "flex", flexWrap: "wrap" }}>
                      {images.map((img) => (
                        <div
                          style={{
                            width: "101px",
                            height: "101px",
                            margin: "5px",
                            border: "1px solid black",
                          }}
                        >
                          <img
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: 0,
                              cursor: "pointer",
                            }}
                            src={environment.dap_url + "" + img}
                            onClick={(e) =>
                              openImage(environment.dap_url + "" + img)
                            }
                          ></img>
                        </div>
                      ))}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Last updated at</th>
                    <td>{updatedAt}</td>
                  </tr>
                  {/* <tr>
                      <th scope="row">Status</th>
                      <td>
                        {ticketStatus.value != "closed" ? (
                          <Select
                            options={[
                              { label: "In Progress", value: "in-progress" },
                              { label: "Hold", value: "hold" },
                              { label: "Close Ticket", value: "closed" },
                            ]}
                            onChange={changeStatus}
                            value={ticketStatus}
                          />
                        ) : (
                          ticketStatus.label
                        )}
                      </td>
                    </tr> */}
                </tbody>
              </table>
            </div>
            <div className="support-card border-bottom py-3">
              <h5>
                <b>Customer Details</b>
              </h5>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th scope="row">Name</th>

                    <td>{dap_name}</td>
                  </tr>
                  <tr>
                    <th scope="row">Email</th>
                    <td>{dap_email}</td>
                  </tr>
                  <tr>
                    <th scope="row">Phone</th>
                    <td>{dap_phone}</td>
                  </tr>
                  <tr>
                    <th width="50%" scope="row">
                      Country
                    </th>
                    <td>{postcountry}</td>
                  </tr>
                  <tr>
                    <th scope="row">State</th>
                    <td>{poststate}</td>
                  </tr>
                  <tr>
                    <th scope="row">City</th>
                    <td>{postcity}</td>
                  </tr>
                  <tr>
                    <th scope="row">Address</th>
                    <td>{dap_address}</td>
                  </tr>
                  <tr>
                    <th scope="row">Zip Code</th>
                    <td>{zip}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-8 border p-0">
            <div className="support-chat">
              <div className="support-chat-header">
                <h5 className="m-0 p-0">
                  <b>Status:</b>
                </h5>{" "}
                {ticketStatus.value != "closed" ? (
                  userType != "CUSTOMER_USER" ? (
                    <Select
                      id="selectStatus"
                      options={[
                        { label: "In Progress", value: "in-progress" },
                        { label: "Hold", value: "hold" },
                        { label: "Close Ticket", value: "closed" },
                      ]}
                      onChange={changeStatus}
                      value={ticketStatus}
                    />
                  ) : (
                    <h5 className="mx-2 p-0 my-0">{ticketStatus.label}</h5>
                  )
                ) : (
                  <h5 className="mx-2 p-0 my-0">{ticketStatus.label}</h5>
                )}
              </div>
              <div className="support-mPanel" id="support-Mpanel">
                <div className="support-inner-panel" id="support-MInnerPanel">
                  {followup.map((follow) => {
                    let dateArr = follow.createdAt.split("T")[0].split("-");
                    let timeArr = follow.createdAt.split("T")[1].split(":");
                    return (
                      <>
                        {/* <span class="scroll-start-at-top"></span> */}
                        {follow.executive_details[0]._id != contactedBy ? (
                          <div class="msg left-msg">
                            <div class="msg-bubble">
                              <div class="msg-info">
                                <div class="msg-info-name">
                                  {follow.executive_details[0].userFirstName}{" "}
                                  {userType != "CUSTOMER_USER"
                                    ? "(" +
                                      follow.executive_details[0].userType +
                                      ")  "
                                    : ""}
                                </div>
                                <div class="msg-info-time">
                                  {dateArr[2] +
                                    "-" +
                                    dateArr[1] +
                                    "-" +
                                    dateArr[0] +
                                    " " +
                                    timeArr[0] +
                                    ":" +
                                    timeArr[1]}
                                </div>
                              </div>

                              <div class="msg-text">
                                <div className="d-flex flex-wrap">
                                  {follow.file.map((url) => (
                                    <div
                                      key={url}
                                      style={{
                                        width: "101px",
                                        height: "101px",
                                        margin: "5px",
                                        border: "1px solid black",
                                      }}
                                    >
                                      {url.endsWith(".jpg") ||
                                      url.endsWith(".png") ? (
                                        <img
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            borderRadius: 0,
                                            cursor: "pointer",
                                          }}
                                          src={environment.dap_url + url}
                                          onClick={() =>
                                            window.open(
                                              environment.dap_url + url,
                                              "_blank"
                                            )
                                          }
                                          alt="Image"
                                        />
                                      ) : url.endsWith(".pdf") ? (
                                        <div
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            backgroundColor: "lightgray",
                                          }}
                                          onClick={() =>
                                            openPdf(
                                              url
                                            )
                                          }
                                        >
                                          <span>Open PDF</span>
                                        </div>
                                      ) : url.endsWith(".mp4") ? (
                                        <div
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            backgroundColor: "lightgray",
                                          }}
                                          onClick={() => openVideo(url)}
                                          >
                                            <span>Play Video</span>
                                          </div>
                                        ) : (
                                          <div>Unsupported File Type</div>
                                        )}
                                      </div>
                                    ))}
                                </div>
                                {follow.note}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div class="msg right-msg">
                            <div class="msg-bubble">
                              <div class="msg-info">
                                <div class="msg-info-name">You</div>
                                <div class="msg-info-time">
                                  {dateArr[2] +
                                    "-" +
                                    dateArr[1] +
                                    "-" +
                                    dateArr[0] +
                                    " " +
                                    timeArr[0] +
                                    ":" +
                                    timeArr[1]}
                                </div>
                              </div>

                              <div class="msg-text">
                                <div className="d-flex flex-wrap">
                                  {follow.file.map((url) => (
                                    <div
                                      key={url}
                                      style={{
                                        width: "101px",
                                        height: "101px",
                                        margin: "5px",
                                        border: "1px solid black",
                                      }}
                                    >
                                      {url.endsWith(".jpg") ||
                                      url.endsWith(".png") ? (
                                        <img
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            borderRadius: 0,
                                            cursor: "pointer",
                                          }}
                                          src={environment.dap_url + url}
                                          onClick={(e) =>
                                            openImage(
                                              environment.dap_url + "" + url
                                            )
                                          }
                                          alt="Image"
                                        />
                                      ) : url.endsWith(".pdf") ? (
                                        <div
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            backgroundColor: "lightgray",
                                          }}
                                          onClick={() =>
                                            openPdf(
                                              url
                                            )
                                          }
                                        >
                                          <span>Open PDF</span>
                                        </div>
                                      ) : url.endsWith(".mp4") ? (
                                        <div
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            backgroundColor: "lightgray",
                                          }}
                                          onClick={() => openVideo(url)}
                                        >
                                          <span>Play Video</span>
                                        </div>
                                      ) : (
                                        <div>Unsupported File Type</div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                                {follow.note}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}

                  {ticketStatus.value == "closed" ? (
                    <h5
                      style={{
                        margin: "10px auto",
                        width: "300px",
                        fontWeight: "600",
                        background: "#cdcdcd",
                        borderRadius: "20px",
                        padding: "5px 15px 5px 15px",
                        textAlign: "center",
                      }}
                    >
                      This ticket has been closed
                    </h5>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {ticketStatus.value != "closed" ? (
                <div className="support-chat-footer">
                  <div className="d-flex">
                    {fileArr.map((f, i) => (
                      <div
                        style={{
                          width: "auto",
                          height: "auto",
                          margin: "5px",
                          border: "1px solid black",
                          position: "relative",
                        }}
                      >
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={(e) => remove(e, i)}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            zIndex: 999,
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                        {/* <img src={f} style={{ width: "100px" }} /> */}
                        {renderFileContent(f)}
                      </div>
                    ))}
                  </div>
                  <div class="d-flex w-100 justify-content-center align-items-center border">
                    <div class=" flex-grow-1">
                      <input
                        onChange={(event)=>{
                          handleChangeForFile(event)
                          event.target.value = null
                        }}
                        name="attachment"
                        type="file"
                        accept=".pdf, .mp4, .avi, .mov, .jpg, .png, .jpeg"
                        id="formFile"
                        multiple
                        style={{ display: "none" }}
                      />
                      <textarea
                        className="form-control"
                        id="note"
                        onChange={(e) => {
                          setNote(e.target.value);
                          setNoteErrors({});
                        }}
                        style={{ border: "none" }}
                        value={note}
                      ></textarea>
                      <div>
                        {Object.keys(noteErrors).map((key) => {
                          return (
                            <p style={{ color: "red" }}>{noteErrors[key]}</p>
                          );
                        })}
                      </div>
                    </div>
                    {/* <div class="d-flex"> */}
                    <Button
                      className="m-1"
                      type="button"
                      variant="primary"
                      onClick={(e) => submitResponse(e)}
                      style={{ height: "36px" }}
                    >
                      Send <i class="fa fa-paper-plane"></i>
                    </Button>
                    {/* </div> */}
                  </div>
                  <label
                    htmlFor="formFile"
                    className="text text-primary"
                    style={{ cursor: "pointer" }}
                  >
                    <i class="fa fa-files-o" aria-hidden="true"></i>
                    Add files...
                  </label>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">

            <Accordion style={{ margin: "10px" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <h4 className="card-title">Ticket Details</h4>
              </AccordionSummary>
              <AccordionDetails>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th scope="row">Ticket Id</th>
                      <td>{ticketId}</td>
                    </tr>
                    <tr>
                      <th scope="row">Assigned to</th>
                      <td>{executiveName}</td>
                    </tr>
                    <tr>
                      <th scope="row">Description</th>
                      <td>{description}</td>
                    </tr>
                    <tr>
                      <th scope="row">Images</th>
                      <td style={{ display: "flex" }}>
                        {images.map((img) => (
                          <div
                            style={{
                              width: "101px",
                              height: "101px",
                              margin: "5px",
                              border: "1px solid black",
                            }}
                          >
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: 0,
                                cursor: "pointer",
                              }}
                              src={environment.dap_url + "" + img}
                              onClick={(e) =>
                                openImage(environment.dap_url + "" + img)
                              }
                            ></img>
                          </div>
                        ))}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Status</th>
                      <td>
                        {ticketStatus.value != "closed" ? (
                          <Select
                            options={[
                              { label: "In Progress", value: "in-progress" },
                              { label: "Hold", value: "hold" },
                              { label: "Close Ticket", value: "closed" },
                            ]}
                            onChange={changeStatus}
                            value={ticketStatus}
                          />
                        ) : (
                          ticketStatus.label
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ margin: "10px" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <h4 className="card-title">Customer Details</h4>
              </AccordionSummary>
              <AccordionDetails>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th scope="row">Name</th>

                      <td>{dap_name}</td>
                    </tr>
                    <tr>
                      <th scope="row">Email</th>
                      <td>{dap_email}</td>
                    </tr>
                    <tr>
                      <th scope="row">Phone</th>
                      <td>{dap_phone}</td>
                    </tr>
                    <tr>
                      <th width="50%" scope="row">
                        Country
                      </th>
                      <td>{postcountry}</td>
                    </tr>
                    <tr>
                      <th scope="row">State</th>
                      <td>{poststate}</td>
                    </tr>
                    <tr>
                      <th scope="row">City</th>
                      <td>{postcity}</td>
                    </tr>
                    <tr>
                      <th scope="row">Address</th>
                      <td>{dap_address}</td>
                    </tr>
                    <tr>
                      <th scope="row">Zip Code</th>
                      <td>{zip}</td>
                    </tr>
                  </tbody>
                </table>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <h5>Follow Ups</h5>
                  {ticketStatus.value != "close" ? (
                    <button
                      className="btn btn-primary"
                      style={{
                        position: "absolute",
                        top: "30px",
                        right: "10px",
                      }}
                      onClick={(e) => setShowFollowUp(true)}
                    >
                      Add Follow-up note
                    </button>
                  ) : (
                    ""
                  )}
                  <div className="col-12">
                    <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={followup}
                      columns={columns}
                      search
                    >
                      {(props) => (
                        <div>
                          <div className="d-flex align-items-center">
                            <p className="mb-2 mr-2">Search in table:</p>
                            <SearchBar {...props.searchProps} />
                          </div>
                          <BootstrapTable
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory()}
                            {...props.baseProps}
                            wrapperClasses="table-responsive"
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>*/}
      <Modal show={showImage} onHide={(e) => setShowImage(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={imgUrl} style={{ height: "75vh", maxWidth: "100%" }} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={(e) => setShowImage(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showPdf} onHide={() => setShowPdf(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Pdf</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <embed
              src={pdfUrl}
              type="application/pdf"
              width="100%"
              height="500px"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowPdf(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showVideo} onHide={() => setShowVideo(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <video
              style={{
                width: "100%",
                height: "100%",
              }}
              controls
            >
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowVideo(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showFollowUp} onHide={(e) => setShowFollowUp(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Follow up</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <Form.Group>
                <Form.Label>Mode</Form.Label>
                <Form.Control
                  id="mode"
                  type="text"
                  placeholder="mode"
                  onChange={(e) => {
                    setMode(e.target.value);
                    setModeErrors({});
                  }}
                ></Form.Control>
                <div>
                  {Object.keys(modeErrors).map((key) => {
                    return <p style={{ color: "red" }}>{modeErrors[key]}</p>;
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col">
              <Form.Group>
                <Form.Label>Response</Form.Label>
                <Select
                  id="response"
                  options={[
                    { label: "Responded", value: true },
                    { label: "Not Responded", value: false },
                  ]}
                  onChange={(e) => handleChangeSelect(e)}
                  value={response}
                />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Form.Group controlId="note">
                <Form.Label>Note</Form.Label>
                <textarea
                  className="form-control"
                  id="note"
                  onChange={(e) => {
                    setNote(e.target.value);
                    setNoteErrors({});
                  }}
                ></textarea>
                <div>
                  {Object.keys(noteErrors).map((key) => {
                    return <p style={{ color: "red" }}>{noteErrors[key]}</p>;
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={(e) => setShowFollowUp(false)}>
            Close
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={(e) => submitResponse(e)}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewTicket;
